import { Reveal } from "../Reveal";
import { Chapter } from "../Chapter";

const POINTS = [
  {
    t: "A space to speak honestly",
    d: "No judgement. No taking sides.",
  },
  {
    t: "A steadier head",
    d: "Enough distance to make decisions you won’t regret.",
  },
  {
    t: "A focus on your children and the long view",
    d: "The relationship may be over. The family doesn’t have to be.",
  },
  {
    t: "Support when it matters",
    d: "One conversation or ongoing support when things aren’t calm.",
  },
];

export const WhatThisIs = () => (
  <section className="mx-auto max-w-6xl px-5 md:px-8 py-20 md:py-28" data-testid="what-this-is-section">
    <Chapter
      n={6}
      kicker="What this is"
      title="Clarity between emotion and action."
    />
    <div className="max-w-3xl">
      {POINTS.map((p, i) => (
        <Reveal key={p.t} delay={i * 0.05}>
          <div
            className="border-t border-ink/10 py-6 last:border-b"
            data-testid={`what-this-is-point-${i}`}
          >
            <h3 className="font-serif text-xl md:text-2xl tracking-tight text-ink">
              {p.t}
            </h3>
            <p className="mt-2 text-base leading-relaxed text-ink/60">{p.d}</p>
          </div>
        </Reveal>
      ))}
      <Reveal delay={0.2}>
        <p className="mt-8 text-sm leading-relaxed text-ink/50" data-testid="what-this-is-disclaimer">
          This isn’t therapy, mediation or legal advice. If something needs
          specialist support, I’ll tell you.
        </p>
      </Reveal>
    </div>
  </section>
);
